import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DEFAULT_ESI_STATUS_OPTIONS } from "@/constants";

/**
 * Hook to fetch ESI status options from the 'estatus_esi' catalog.
 * Falls back to DEFAULT_ESI_STATUS_OPTIONS if empty or failed.
 */
export function useEsiStatusOptions() {
  const { data, isLoading } = useQuery({
    queryKey: ["catalogs", "estatus_esi"],
    queryFn: async () => (await api.get("/catalogs", { params: { type: "estatus_esi" } })).data,
    staleTime: 30_000,
  });
  const items = (data || []).map((c) => c.name);
  return {
    options: items.length > 0 ? items : DEFAULT_ESI_STATUS_OPTIONS,
    isLoading,
  };
}
